import React, { useState, useEffect } from 'react'
import { styled, Grid } from '@mui/material'
import {
  AdaptativeGridContainer,
  DefaultPainel
} from '../../../components/shared'
import Dater from '../../../services/DateFormat'
import TableGestao from '../styles/TableGestao'
import { Star, Brightness1 } from '@mui/icons-material'
import { array } from 'prop-types'

const RelatorioADM = styled('p')(() => ({
  fontWeight: 'bolder'
}))

const Icons = {
  1: <Star color="warning" />,
  2: <Brightness1 color="error" />,
  3: <RelatorioADM>ADM</RelatorioADM>
}

const GeraIcons = value => {
  return Icons[value]
}

const RelatorioLeitura = ({ relatorioData }) => {
  const [rows, setRows] = useState([])

  useEffect(() => {
    setRows(relatorioData)
  }, [relatorioData])

  const geraColunas = () => {
    const meses = Dater().meses

    const columns = meses.map(item => {
      const mes = item.nome.toLowerCase()
      return {
        field: mes,
        headerName: 'Jan',
        flex: 1,
        renderCell: ({ row }) => {
          return GeraIcons(row[mes])
        }
      }
    })
    return columns
  }

  const columns = [
    {
      field: 'janeiro',
      headerName: 'Jan',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.janeiro)
      }
    },
    {
      field: 'fevereiro',
      headerName: 'Fev',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.fevereiro)
      }
    },
    {
      field: 'marco',
      headerName: 'Mar',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.marco)
      }
    },
    {
      field: 'abril',
      headerName: 'Abr',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.abril)
      }
    },
    {
      field: 'maio',
      headerName: 'Mai',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.maio)
      }
    },
    {
      field: 'junho',
      headerName: 'Jun',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.junho)
      }
    },
    {
      field: 'julho',
      headerName: 'Jul',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.julho)
      }
    },
    {
      field: 'agosto',
      headerName: 'Ago',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.agosto)
      }
    },
    {
      field: 'setembro',
      headerName: 'Set',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.setembro)
      }
    },
    {
      field: 'outubro',
      headerName: 'Out',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.outubro)
      }
    },
    {
      field: 'novembro',
      headerName: 'Nov',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.novembro)
      }
    },
    {
      field: 'dezembro',
      headerName: 'Dez',
      flex: 1,
      renderCell: ({ row }) => {
        return GeraIcons(row.dezembro)
      }
    }
  ].map(item => {
    return {
      ...item,
      headerClassName: 'styledHeader',
      sortable: false,
      align: 'center'
    }
  })

  useEffect(() => {
    geraColunas()
  }, [])

  return (
    <>
      <DefaultPainel
        sx={{
          padding: '4px 0px',
          boxShadow: 'none',
          marginBottom: '-100px',
          width: '100%'
        }}
      >
        <AdaptativeGridContainer>
          <>
            <Grid item xs={12} sm={12}>
              <TableGestao
                columns={columns}
                rows={rows}
                rowsPerPageOptions={[10]}
                disableColumnMenu
                disableColumnSelector
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </>
  )
}
RelatorioLeitura.propTypes = {
  relatorioData: array
}
export default RelatorioLeitura
